import React, { forwardRef } from 'react';
import cn from 'classnames';
import styles from './TableRow.module.scss';

const TableRow = forwardRef(
  ({ className, hovered = false, withCheckbox = false, ...props }, ref) => {
    return (
      <tr
        {...props}
        ref={ref}
        className={cn(styles.root, className, {
          [styles.hovered]: hovered && !withCheckbox,
          [styles.hoveredWithCheckbox]: hovered && withCheckbox,
        })}
      />
    );
  }
);

export default TableRow;
